import React from 'react';
import { Typography, Row, Col, Space } from 'antd';
import appPreview from '../assets/IMG_35815AB33545-1.jpeg';  // 添加这行

const { Title, Paragraph } = Typography;

const ProductDescription = () => {
  return (
    <div style={{ padding: '60px 50px', background: '#f8f9fa' }}>
      <Row gutter={[48, 48]} align="middle">
        <Col xs={24} md={12}>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Title level={2}>Lifeano APP</Title>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
              Lifeano APP是聚焦文化类音频和视频的移动端产品，通过文化了解世界，通过世界探究自我，用文化给生活另一种可能。
            </Paragraph>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
            文化名人：袁腾飞、曾仕强、钱文忠、傅佩荣、毕淑敏等，众多新锐：赛艇队长、三喵先生、谢承汇、胡思小姐姐。。。
世界包罗万象，文学、艺术、哲学、政治、经济、科技、战争，世界在历史车轮的滚动下不断演变；
人心变幻莫测，欢喜、厌恶、悲哀、愤怒、恐惧、意外，（给翻译：人的6大基本情绪，源头来自英文）贪婪、怨恨、愚昧、自大、多疑，（给翻译：源自佛典贪嗔痴慢疑，参考：Greed, Resentment, Ignorance, Arrogance, Suspicion）慈悲、智慧，
读历史即是读人心-人性心性矣；
智者认知事物可以融会贯通，思考问题能够高瞻远瞩；愚民查看问题往往偏激狭隘，甚至连眼前事都看不清。
欢迎加入LIFEANO，了解世界，改变自己。
            </Paragraph>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
            Give your life another chance! Live your life another way! LIFEANO
            </Paragraph>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
              主要功能：
              <ul>
                <li>历史文化类音视频在线播放</li>
                <li>高级会员</li>
                <li>线下历史文化类研学活动</li>
                <li>音视频下载</li>
                <li>优惠活动</li>
              </ul>
            </Paragraph>
          </Space>
        </Col>
        <Col xs={24} md={12} style={{ textAlign: 'center' }}>
          <img 
            src={appPreview}
            alt="Lifeano APP Preview" 
            className="app-preview-image"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProductDescription;